module.exports = __webpack_public_path__ + "static/media/background-email.ca564dce.svg";